<template lang="pug">
div(style="height:100%")
  .internal-nav
    router-link(:to="{name: 'Deals'}" v-if="userCanViewDeals") Deals
    router-link(:to="{name: 'Products'}" v-if="userCanViewProducts") Products
    router-link(:to="{name: 'Resources'}" v-if="userCanViewResources") Resources
  GreyPage
    transition(name="fade" mode="out-in")
      router-view
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BriqInventory',
  computed: {
    ...mapGetters('briqState', ['userHasPermission']),
    userCanViewProducts() {
      return this.userHasPermission('API_Admin_Product_Index')
    },
    userCanViewDeals() {
      return this.userHasPermission('API_Admin_ProductGroup_Index')
    },
    userCanViewResources() {
      return this.userHasPermission('API_Admin_Resource_Index')
    },
  },
}
</script>

<style scoped lang="stylus">
.internal-nav
  display flex
  border-bottom solid 1px #ececec
  padding-left 28px

  a
    padding 27px 18px
    font-size 16px
    color #2c333a
    transition color 0.2s ease

    &:hover
      color #009bff

    &.router-link-active
      font-weight bold
</style>
